import { render, staticRenderFns } from "./epms2020.vue?vue&type=template&id=4da06087&scoped=true"
import script from "./epms2020.vue?vue&type=script&lang=js"
export * from "./epms2020.vue?vue&type=script&lang=js"
import style0 from "./epms2020.vue?vue&type=style&index=0&id=4da06087&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da06087",
  null
  
)

export default component.exports